function Agreement() {
  return (
    <div
      style={{
        width: "90%",
      }}
    >
      <div>
        <p>
          <strong>CANDYLAND ADVENTURE INDOOR PLAYGROUND</strong>
        </p>
        <p>
          <strong>LeadKiddo Oasis LLC</strong>
        </p>
        <p>
          <strong>WAIVER, RELEASE, AND INDEMNIFICATION AGREEMENT</strong>
        </p>
        <p>
          <strong>
            PLEASE READ THIS DOCUMENT CAREFULLY. BY SIGNING, YOU ARE GIVING UP
            LEGAL RIGHTS
          </strong>
        </p>
        <p>
          This Waiver, Release, and Indemnification Agreement (Agreement) is
          entered into by the Adult Participant, and if any minor(s) is/are
          named below, the Adult Participant on behalf of and as parent or legal
          guardian for such Child Participant(s) identified below in favor of
          LeadKiddo Oasis LLC (Candyland Adventure). Collectively and severally,
          Adult Participant and Child Participant, their heirs, successors, and
          assigns are hereinafter referred to as the Participant. In
          consideration of Candyland Adventure permitting Participant to enter
          the Premises and participate in the Activities, Participant agrees as
          follows:
        </p>
        <p>
          <strong>1. Description of Activities</strong>
        </p>
        <p>
          LeadKiddo Oasis LLC (Candyland Adventure) offers various indoor
          playground activities including, but not limited to, climbing
          structures, slides, obstacle courses, soft play areas, and themed
          events. Participants may engage in these activities actively or
          passively.
        </p>
        <p>
          <strong>2. Acknowledgement of Risks</strong>
        </p>
        <p>
          <strong>2.1 Risks and Injuries Associated with Activities</strong>
        </p>
        <p>
          Participant acknowledges that participation in the Activities involves
          inherent risks which may result in injuries such as, but not limited
          to, equipment failure, slips, trips, falls, collisions, sprains,
          strains, fractures, concussions, and other physical or emotional
          injuries. Participant understands and accepts these risks.
        </p>
        <p>
          <strong>2.2 Health Risks</strong>
        </p>
        <p>
          By entering the Premises or participating in the Activities,
          Participant acknowledges the potential exposure to bacteria, fungi,
          viruses, including COVID-19, and other contagious diseases. LeadKiddo
          Oasis LLC (Candyland Adventure) cannot eliminate these risks despite
          following all recommended health guidelines. Participant assumes all
          risks related to exposure to such pathogens and consents to health
          screenings such as temperature checks. Participant may be denied entry
          or asked to leave if showing symptoms of illness.
        </p>
        <p>
          <strong>3. Assumption of Risks</strong>
        </p>
        <p>
          Participant voluntarily assumes all risks associated with
          participation in the Activities and entry into the Premises,
          understanding that despite safety measures, injuries and illnesses can
          occur.
        </p>
        <p>
          <strong>4. Health and Safety</strong>
        </p>
        <p>
          Participant affirms that they are in good health and have no medical
          conditions that would prevent safe participation in the Activities.
          Participant agrees to follow all safety instructions and rules
          provided by LeadKiddo Oasis LLC (Candyland Adventure) staff.
        </p>
        <p>
          Sharp objects are strictly prohibited in the play area. Parents or
          guardians agree to thoroughly check their children's pockets, bags,
          and belongings to ensure that no sharp or dangerous items are brought
          into the playground.
        </p>
        <p>
          <strong>5. Release and Indemnity</strong>
        </p>
        <p>
          To the fullest extent permitted by law, Participant releases and
          agrees to indemnify and hold harmless LeadKiddo Oasis LLC, its
          employees, agents, and affiliates from any claims arising out of or
          related to Participant’s participation in the Activities or use of the
          Premises, including claims arising from the negligence of LeadKiddo
          Oasis LLC (Candyland Adventure).
        </p>
        <p>
          <strong>6. Emergency Medical Treatment</strong>
        </p>
        <p>
          In case of emergency, Participant consents to receive medical
          treatment deemed necessary by medical professionals and agrees to be
          responsible for any costs associated with such treatment.
        </p>
        <p>
          <strong>7. Alcohol and Drug Use</strong>
        </p>
        <p>
          Participant agrees not to participate in any Activities under the
          influence of alcohol or drugs. Participant understands that impairment
          increases the risk of injury and assumes full responsibility for their
          actions, safety, and welfare.
        </p>
        <p>
          <strong>8. Photography and Media</strong>
        </p>
        <p>
          Participant grants LeadKiddo Oasis LLC (Candyland Adventure) the right
          to use photographs or videos taken during participation in the
          Activities for promotional purposes without compensation. Participant
          waives the right to inspect or approve the final versions of such
          media.
        </p>
        <p>
          <strong>9. Dispute Resolution</strong>
        </p>
        <p>
          <strong>A. Arbitration</strong>
        </p>
        <p>
          Any dispute arising out of or relating to this Agreement shall be
          resolved by binding arbitration administered by the American
          Arbitration Association (AAA) under its Commercial Industry
          Arbitration Rules. The arbitration will take place before a single
          arbitrator. Judgment on the arbitration award may be entered in any
          court having jurisdiction. The arbitrator shall not have the authority
          to award punitive or exemplary damages.
        </p>
        <p>
          <strong>B. Waiver of Jury Trial</strong>
        </p>
        <p>
          Participant and LeadKiddo Oasis LLC (Candyland Adventure) agree to
          waive their right to a trial by jury for any disputes arising out of
          this Agreement. This waiver is made knowingly and voluntarily.
        </p>
        <p>
          <strong>10. Acknowledgments and Representations</strong>
        </p>
        <p>
          Participant acknowledges that this Agreement constitutes the entire
          agreement between the parties and supersedes any prior agreements or
          representations, whether written or oral. Participant affirms that
          they have read and understood this Agreement and agree to be bound by
          its terms. Participant understands that this Agreement cannot be
          modified except in writing signed by both parties.
        </p>
        <p>
          <strong>11. Severability</strong>
        </p>
        <p>
          If any part of this Agreement is found to be invalid or unenforceable,
          the remaining provisions shall continue in full force and effect.
        </p>
        <p>
          <strong>
            By signing below, I acknowledge that I have read, understood, and
            agree to the terms of this Waiver, Release, and Indemnification
            Agreement.
          </strong>
          <p>
            <strong>
              By signing below, I consent CandylandAdventure to collect my
              minor's name, birthday, and relation to guardian only as necessary
              to provide its services.
            </strong>
          </p>
          <p>
            Please read{" "}
            <a href="https://www.candylandadventure.com/privacy">
              CandylandAdventure's privacy policy{" "}
            </a>
            for detail
          </p>
        </p>
      </div>
    </div>
  );
}

export default Agreement;
